import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import {
  createAssessmentAPIEndpoint,
  EndPoints,
} from "../../../services/AssessmentServices";

function AssessmentResult() {
  const { id } = useParams();
  const [result, setResult] = useState(null);

  useEffect(() => {
    const removeFullscreen = () => {
      if (document.fullscreenElement) {
        document.exitFullscreen().catch((err) => {
          console.warn("Error exiting fullscreen:", err);
        });
      }
    };

    removeFullscreen();

    createAssessmentAPIEndpoint(EndPoints.getSubmissionResult(id))
      .fetch()
      .then((res) => setResult(res.data))
      .catch((err) => console.error("Error fetching result:", err));
  }, [id]);

  if (!result) return <div>Loading...</div>;

  return (
    <div className="assessment-result" translate="no">
      <h2 className="title">{result.title}</h2>
      <p className="score">
        Score: {result.score} / {result.totalPoints}
      </p>

      {result.questions.map((q, index) => (
        <div key={index} className="question">
          <h4 className="question-text">{q.questionText}</h4>
          <ul>
            {JSON.parse(q.optionsJson).map((opt, i) => {
              const isCorrect = q.correctOptionsIndex === i;
              const isSelected = q.selectedOptionIndex === i;

              return (
                <li
                  key={i}
                  className={`
              option 
              ${isCorrect ? "correct-answer" : ""}
              ${isSelected && !isCorrect ? "wrong-answer" : ""}
            `}
                >
                  {opt}
                  {/* If this option was the one chosen */}
                  {isSelected && !isCorrect && (
                    <span className="icon"> ❌</span>
                  )}
                  {isCorrect && <span className="icon"> ✅</span>}
                </li>
              );
            })}
          </ul>

          {/* Handle unanswered case */}
          {q.selectedOptionIndex === -1 && (
            <p className="no-answer ">
              You didn’t choose any answer for this question.
            </p>
          )}

          {/* Overall correctness display */}
          {/* <p className="mt-2 font-semibold">
            {q.isCorrect
              ? "✅ Correct"
              : q.selectedOptionIndex === -1
              ? "⚠️ Unanswered"
              : "❌ Incorrect"}
          </p> */}
        </div>
      ))}
    </div>
  );
}

export default AssessmentResult;
